<div #container class="ad-doc-viewer-container" [innerHTML]="html">
  <div class="ad-doc-viewer-loading" [hidden]="html">
    <div>
      <div class="ad-doc-viewer-loading-title">
        Preparing document for viewing...
      </div>
      <ad-skeleton count="1"></ad-skeleton>
    </div>
  </div>
</div>
